<template lang="pug">
.resident-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：家族ユーザー
    template(#cell(family)="row")
      .d-flex.flex-row.justify-content-center.align-items-center
        .family-count
          span {{ row.item.familyCount }}人
        .family-detail
          button.btn.family-detail-btn.disable(v-if="row.item.familyCount <= 0" disabled) 詳細
          button.btn.family-detail-btn(v-else @click="onShowFamilies(row.item)") 詳細
    // セル：ID通知書
    template(#cell(print)="row")
      button.btn.print-btn(@click="onShowServiceRegisterGuide(row.item)") 印刷
    // セル：登録情報
    template(#cell(operation)="row")
      button.btn.edit-btn(@click="onDetail(row.item.id)") 詳細
      button.btn.edit-btn(@click="onGotoResidentEdit(row.item.id)") 修正
      button.btn.delete-btn(@click="onShowConfirmDeleteModal(row.item)" type="button") 削除
</template>

<script lang="ts">
import { ResidentGetModel } from "@/commons/services/Residents";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 利用者テーブルコンポーネント
 */
@Component({})
export default class ResidentTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<ResidentTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<ResidentTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<ResidentTableItem> {
    return this.value;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: ResidentTableItem, filter: FilterSetting): boolean {
    return this.filterGroupId(row, filter) && this.filterSearchWords(row, filter);
  }

  public filterGroupId(row: ResidentTableItem, filter: FilterSetting): boolean {
    if (filter.id == "") {
      return true;
    }

    if (row.groupId == Number(filter.id)) {
      return true;
    } else {
      return false;
    }
  }

  public filterSearchWords(row: ResidentTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundResidentKanaName: boolean = true;
    let foundResidentName: boolean = true;
    let foundRoom: boolean = true;

    for (const word of words) {
      // 利用者名
      if (row.name.indexOf(word) == -1) {
        foundResidentName = false;
      }

      // ふりがなが登録されている場合は文字列を含むかチェックする
      if (row.kanaName) {
        if (row.kanaName.indexOf(word) == -1) {
          foundResidentKanaName = false;
        }
      }
      // ふりがなが登録されていない場合は対象外として扱う
      else {
        foundResidentKanaName = false;
      }

      // 部屋名
      if (row.room.indexOf(word) == -1) {
        foundRoom = false;
      }
    }

    return foundResidentKanaName || foundResidentName || foundRoom;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onShowFamilies(resident: ResidentTableItem): void {
    this.$emit("onShowFamilies", resident);
    return;
  }

  /**
   * ### 印刷ボタン押下イベント
   */
  public onShowServiceRegisterGuide(resident: ResidentTableItem): void {
    this.$emit("onShowServiceRegisterGuide", resident);
    return;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onDetail(residentId: number): void {
    this.$emit("onDetail", residentId);
    return;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onGotoResidentEdit(residentId: number): void {
    this.$emit("onGotoResidentEdit", residentId);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onShowConfirmDeleteModal(resident: ResidentTableItem): void {
    this.$emit("onShowConfirmDeleteModal", resident);
    return;
  }
}

/** テーブルの列名の情報 */
export interface ResidentTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface ResidentTableItem extends ResidentGetModel {}

export interface FilterSetting {
  id: string;
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.resident-table-component {
  .family-detail-btn,
  .print-btn,
  .edit-btn,
  .delete-btn {
    width: 64px;
  }

  .edit-btn {
    margin-right: 8px;
  }

  .family-count {
    word-break: break-all;
    width: 55px;
    text-align: center;
  }
  .family-detail {
    width: 64px;
    text-align: center;
  }
}
</style>
